import $P from 'plugins/kapida/platformConfigs/integrationMaps/signin';
import { objectSelector } from 'theme/utils';

class SignInSmsRejected {
  constructor(data) {
    const { phone, smsCode } = data;
    this.phone = phone;
    this.smsCode = smsCode;
  }
}

export const signInSmsRejectedMapper = (error) => {
  return new SignInSmsRejected({
    phone: objectSelector(error, $P.ERROR_MESSAGES.PHONE),
    smsCode: objectSelector(error, $P.ERROR_MESSAGES.SMS_CODE),
  });
};



// WEBPACK FOOTER //
// ./src/models/kapidaModels/signInSmsRejected.js